import script from "./LoginMainMobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginMainMobile.vue?vue&type=script&lang=ts&setup=true"

import "./LoginMainMobile.vue?vue&type=style&index=0&id=419c15a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-419c15a6"]])

export default __exports__